import { useEffect, useState } from "react";
import { Routes, Route, Navigate, Link, useNavigate } from "react-router-dom";
import { Icon } from "../../icons/Icon";
import { Brasao, Carregando } from "../../components/Layout";
import { api, type SessaoCandidato } from "../../lib/api";
import { MinhasInscricoes } from "./MinhasInscricoes";
import { NovaInscricao } from "./NovaInscricao";
import { DetalheInscricao } from "./DetalheInscricao";
import { Perfil } from "./Perfil";

/** Casca autenticada da área do candidato — mesmo padrão de guarda de sessão do painel da comissão. */
export function Area() {
  const [sessao, setSessao] = useState<SessaoCandidato | null>(null);
  const navigate = useNavigate();

  async function carregar() {
    try {
      setSessao(await api.get<SessaoCandidato>("/api/candidato/sessao"));
    } catch {
      setSessao({ autenticado: false, nome: null, cpf: null });
    }
  }

  useEffect(() => { void carregar(); }, []);
  useEffect(() => { document.title = "Minha área | SEMED Baixo Guandu"; }, []);

  async function sair() {
    try { await api.post("/api/candidato/logout"); } catch { /* sessão já encerrada */ }
    navigate("/entrar");
  }

  if (!sessao) return <div className="tema-candidato tc-casca"><Carregando texto="Verificando sua sessão" /></div>;
  if (!sessao.autenticado) return <Navigate to="/entrar" replace />;

  return (
    <div className="tema-candidato tc-casca">
      <header className="tc-topo">
        <div className="tc-topo-interno">
          <Link to="/area" className="linha" style={{ textDecoration: "none", color: "inherit" }}>
            <Brasao tamanho={28} />
            <strong>Minha área</strong>
          </Link>

          <div className="linha" style={{ gap: "var(--space-4)" }}>
            <span className="tc-ajuda">{sessao.nome}</span>
            <Link to="/area/perfil" className="tc-btn tc-btn-outline">
              <Icon nome="editar" tamanho={16} />
              Meu perfil
            </Link>
            <button type="button" className="tc-btn tc-btn-secundario" onClick={sair}>
              <Icon nome="cadeado" tamanho={16} />
              Sair
            </button>
          </div>
        </div>
      </header>

      <div className="tc-conteudo">
        <Routes>
          <Route path="/area" element={<MinhasInscricoes />} />
          <Route path="/area/nova-inscricao" element={<NovaInscricao />} />
          <Route path="/area/inscricoes/:id" element={<DetalheInscricao />} />
          <Route path="/area/perfil" element={<Perfil />} />
          <Route path="*" element={<Navigate to="/area" replace />} />
        </Routes>
      </div>
    </div>
  );
}
